import { ChangeDetectionStrategy, Component, ViewEncapsulation, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { AppService } from './app.service';
import { AuthService } from '@core/state/auth/auth.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, combineLatest } from 'rxjs';
import { RouterService } from '@core/state/router/router.service';
import { IAppRouterState } from '@core/state/router/router-state';
import { LOGIN, ONBOARDING } from '@core/router/app-states';
import { ContextBarTarget } from '@shared/directives/context-bar/context-bar-target';
import { SessionService } from '@core/state/session/session.service';
import { AppFlavour } from '@core/models/config/app-flavour';
import { environment } from '@environments/environment';

@Component({
    standalone: false,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'pay-app',
    templateUrl: './app.component.html',
    styleUrls: [
        './app.component.scss',
        environment.flavour === AppFlavour.DEFAULT ? '../styles/index.scss' : '../styles/index-shift4.scss'
    ],
    host: {
        class: 'c-app'
    }
})
export class AppComponent implements OnInit, AfterViewInit {

    public readonly LOGIN = LOGIN;
    public readonly ONBOARDING = ONBOARDING;
    public readonly CONTEXT_BAR_TARGET_MAIN: ContextBarTarget = ContextBarTarget.MAIN;
    public readonly APP_FLAVOUR: typeof AppFlavour = AppFlavour;
    public isSessionReady = false;

    public title = 'payroll-web';
    public isAuthenticated = false;
    public currentStateName: string;
    public appFlavour: string = environment.flavour;

    private destroyed$: Subject<void> = new Subject();

    constructor(private appService: AppService,
                private authService: AuthService,
                private routerService: RouterService,
                private sessionService: SessionService,
                private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {

        this.sessionService.isSessionInitComplete()
            .pipe(
                takeUntil(this.destroyed$)
            )
            .subscribe((isSessionInitComplete: boolean) => {
                this.isSessionReady = isSessionInitComplete;
                this.cdr.markForCheck();
            });

        this.sessionService.isSessionInitComplete()
            .pipe(takeUntil(this.destroyed$))
            .subscribe((isSessionInitComplete: boolean) => {
                this.isSessionReady = isSessionInitComplete;
                this.cdr.markForCheck();
            });

        this.routerService.getCurrentState()
            .pipe(takeUntil(this.destroyed$))
            .subscribe((routerState: IAppRouterState) => {
                this.currentStateName = routerState.name;
                this.cdr.markForCheck();
            });

        this.authService.isAuthenticated()
            .pipe(takeUntil(this.destroyed$))
            .subscribe((isAuthenticated) => {
                this.isAuthenticated = isAuthenticated;
                this.cdr.markForCheck();
            });
    }

    ngAfterViewInit(): void {
        this.appService.initApp();
    }
}
